<div class="margin">
    <!-- <agm-map #gm
    (mapReady)="mapReading()"
        [zoom]="zoom"
       [latitude]='lat' 
       [longitude]='lng'
       [styles]="style"
       [fitBounds]="true"
       [restriction]="countryRestriction"
       >
       
        <agm-marker 
        *ngFor="let marker of markers;"
            [latitude]="marker.current_lat" 
            [longitude]="marker.current_lon"
            [agmFitBounds]="true"
            (mouseOver)="onMouseOver(infoWindow, $event)"
            (mouseOut)="onMouseOut(infoWindow, $event)"
            (markerClick)="dialog(marker.current_lat, marker.current_lon,marker.mmsid, marker.Ship)"
            [iconUrl] ="{
                path: 'm0.812665,23.806608l37.937001,-22.931615l-21.749812,38.749665l1.374988,-17.749847l-17.562177,1.931797z',
                fillColor: 'green',
                fillOpacity: 1.0,
                scale: .5,
                strokeColor: 'green',
                rotation: marker.heading
            }"
            >
            <agm-info-window [disableAutoPan]="false" #infoWindow>
    
                <div style="width:160px">
                    <label class="toolHead">Name: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.Ship}} <i class="fa fa-angle-double-right"></i></a><br>
                    <label class="toolHead">Owner: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.master_operator}} <i class="fa fa-angle-double-right"></i></a><br>
                    <label class="toolHead">DWT: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.DWT|
                        number}} <i class="fa fa-angle-double-right"></i></a><br>
                    <label class="toolHead">ETA: </label><a (click)="onClickInfoView({id:m.id})" class="">{{marker.eta_time | date:'yyyy-MM-dd'}} <i class="fa fa-angle-double-right"></i></a><br>
                 </div>
    
         </agm-info-window>
                 
        </agm-marker>
       
    </agm-map> -->
    <!-- <div style="float: right; margin-right: 20px; margin-top: 12px;">
        <svg width="15" height="10">
            <path d="m0.812665,23.806608l37.937001,-22.931615l-21.749812,38.749665l1.374988,-17.749847l-17.562177,1.931797z"
            fill-opacity="1.0" stroke-opacity="null" stroke-width="1" stroke="green" fill="green" scale="0.25"/>
        </svg>
        <span class="legend"> Ships whose last reported position is within 7 days</span></div>
    <div style="float: right; margin-right: 10px; margin-top: 12px;">
        <svg width="15" height="10">
            <path d="m0.812665,23.806608l37.937001,-22.931615l-21.749812,38.749665l1.374988,-17.749847l-17.562177,1.931797z"
            fill-opacity="1.0" stroke-opacity="null" stroke-width="1" stroke="red" fill="red" scale="0.25"/>
        </svg>
        <span class="legend"> Ships which did not report their position in last 7 days</span></div> -->
    </div>
    <!-- <app-dropdown (messageEvent)="receiveMessage($event)"></app-dropdown> -->
    
    